module.exports = __webpack_public_path__ + "static/img/success-2.2dfad65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/downloadPanel/success-2.png
// module id = 673
// module chunks = 12